import * as React from "react";
import styled from "styled-components";
import { VerticalSpacer } from "../Spacers";
import { theme } from "../../../theme";
import BodySmall from "../typography/BodySmall";

interface Props {
  onClick: (e?: React.MouseEvent) => void;
  title: string;
  color?: string;
  icon?: React.ReactNode;
}

const Container = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  font-size: 14px;
  color: ${theme.colors.text};
  background-color: transparent;
  cursor: pointer;
  border-bottom: 1px solid transparent;

  &:hover {
    border-bottom: 1px solid ${theme.colors.text};
  }

  &:active {
    border-bottom: none;
    color: black;
  }
`;

const DetailsButton: React.FC<Props> = ({
  onClick,
  title,
  color = theme.colors.text,
  icon,
}) => {
  return (
    <Container onClick={onClick}>
      <BodySmall color={color}>{title}</BodySmall>
      {icon && <VerticalSpacer spacing={0.25} />}
      {icon && icon}
    </Container>
  );
};

export default DetailsButton;
